import img1 from "../../assets/img/partners/1.png";
import img2 from "../../assets/img/partners/2.png";
import img3 from "../../assets/img/partners/3.png";
import img4 from "../../assets/img/partners/4.png";
import img5 from "../../assets/img/partners/5.png";
import img6 from "../../assets/img/partners/6.png";
import img7 from "../../assets/img/partners/7.png";
import img8 from "../../assets/img/partners/8.png";
import img9 from "../../assets/img/partners/9.png";
import img10 from "../../assets/img/partners/10.png";
import img11 from "../../assets/img/partners/11.png";
import img12 from "../../assets/img/partners/12.png";
import img13 from "../../assets/img/partners/13.png";
import img14 from "../../assets/img/partners/14.png";
import img15 from "../../assets/img/partners/15.png";
import img16 from "../../assets/img/partners/16.png";
import img17 from "../../assets/img/partners/17.png";
import img18 from "../../assets/img/partners/18.png";
import img19 from "../../assets/img/partners/19.png";
import img20 from "../../assets/img/partners/20.png";
import img21 from "../../assets/img/partners/21.png";
import img22 from "../../assets/img/partners/22.png";
import img23 from "../../assets/img/partners/23.png";

export const TeamData = [
  {
    img: img12,
    name: "Kumail Polani",
    des: "CEO",
  },
  {
    img: img1,
    name: "Tariq Polani",
    des: "Chairman",
  },
  {
    img: img2,
    name: "Khizer Polani",
    des: "COO",
  },
  {
    img: img3,
    name: "Shayan Polani",
    des: "Director",
  },
  {
    img: img4,
    name: "Saad Polani",
    des: "Director",
  },
  {
    img: img5,
    name: "  Asif Ghouri ",
    des: "Director",
  },
  {
    img: img6,
    name: " Azizullah ",
    des: "Director",
  },
  {
    img: img7,
    name: "Moiz Dabbawala",
    des: "Director",
  },
  {
    img: img8,
    name: "Adeel Ansari",
    des: "Director",
  },
  {
    img: img9,
    name: "Shahid Gujjar",
    des: "Director",
  },
  {
    img: img10,
    name: "Anwer Zaidi",
    des: "Director",
  },
  {
    img: img11,
    name: "Owais Agha",
    des: "Director",
  },
  {
    img: img12,
    name: "Owais Agha",
    des: "Director",
  },
  {
    img: img13,
    name: "Owais Agha",
    des: "Director",
  },
  {
    img: img14,
    name: "Owais Agha",
    des: "Director",
  },
  {
    img: img15,
    name: "Owais Agha",
    des: "Director",
  },
  {
    img: img16,
    name: "Owais Agha",
    des: "Director",
  },
  {
    img: img17,
    name: "Owais Agha",
    des: "Director",
  },
  {
    img: img18,
    name: "Owais Agha",
    des: "Director",
  },
  {
    img: img19,
    name: "Owais Agha",
    des: "Director",
  },
  {
    img: img20,
    name: "Owais Agha",
    des: "Director",
  },
  {
    img: img21,
    name: "Owais Agha",
    des: "Director",
  },
  {
    img: img22,
    name: "Owais Agha",
    des: "Director",
  },
];
